(function () {
  if (window.themeCopyLinkInitialized) return;
  window.themeCopyLinkInitialized = true;

  const SUCCESS_CLASS = "copied";
  const ERROR_CLASS = "notCopied";
  const RESET_DELAY = 1000;

  const resetTimers = new WeakMap();

  function showTooltip(button, stateClass) {
    button.classList.remove(SUCCESS_CLASS, ERROR_CLASS);
    void button.offsetWidth;
    button.classList.add(stateClass);

    clearTimeout(resetTimers.get(button));
    resetTimers.set(
      button,
      setTimeout(() => {
        button.classList.remove(stateClass);
        resetTimers.delete(button);
      }, RESET_DELAY)
    );
  }

  function legacyCopy(url) {
    const textArea = document.createElement("textarea");

    textArea.value = url;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.top = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();

    let successful = false;

    try {
      successful = document.execCommand("copy");
    } catch (error) {
      successful = false;
    }

    document.body.removeChild(textArea);

    return successful;
  }

  function handleCopy(event) {
    const button = event.target.closest(".copy-btn");

    if (!button) return;

    event.preventDefault();

    const url =
      button.dataset.copyHref ||
      button.getAttribute("href") ||
      window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => showTooltip(button, SUCCESS_CLASS))
        .catch(() =>
          showTooltip(button, legacyCopy(url) ? SUCCESS_CLASS : ERROR_CLASS)
        );
    } else {
      showTooltip(button, legacyCopy(url) ? SUCCESS_CLASS : ERROR_CLASS);
    }
  }

  document.addEventListener("click", handleCopy);
})();
